import { motion, useReducedMotion } from "framer-motion";

import { HERO } from "../../data/home";
import { SITE } from "../../data/site";

// First paint only: the two name lines rise out of their masks, everything else
// fades up behind them, and the portrait settles from a slight scale.
const Hero = () => {
	const reduceMotion = useReducedMotion();

	const fadeUp = (duration, delay) =>
		reduceMotion
			? {}
			: {
					initial: { opacity: 0, y: 10 },
					animate: { opacity: 1, y: 0 },
					transition: { duration, delay, ease: "easeOut" },
			  };

	return (
		<section className="wrap hero-sec">
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					gap: "clamp(32px, 5vw, 72px)",
					alignItems: "flex-start",
				}}
			>
				<div style={{ flex: "1 1 420px", minWidth: 0 }}>
					<motion.div
						className="eyebrow"
						style={{ marginBottom: "clamp(20px, 3vw, 34px)" }}
						{...fadeUp(0.56, 0.06)}
					>
						{HERO.eyebrow}
					</motion.div>

					<h1 className="h-hero">
						{SITE.nameLines.map((line, index) => (
							<span className="h-hero-line" key={line}>
								{reduceMotion ? (
									<span style={{ display: "block" }}>{line}</span>
								) : (
									<motion.span
										style={{ display: "block" }}
										initial={{ y: "106%" }}
										animate={{ y: 0 }}
										transition={{
											duration: 0.76,
											delay: index * 0.09,
											ease: [0.16, 1, 0.3, 1],
										}}
									>
										{line}
									</motion.span>
								)}
							</span>
						))}
					</h1>

					<motion.p className="lede" {...fadeUp(0.64, 0.15)}>
						{HERO.lede}
					</motion.p>

					<motion.div
						style={{
							display: "flex",
							flexWrap: "wrap",
							gap: "28px",
							marginTop: "clamp(28px, 4vw, 44px)",
						}}
						{...fadeUp(0.64, 0.24)}
					>
						<a href="#work" className="link-mono-strong">
							Selected work
						</a>
						{/* <a
							href={SITE.scholar}
							target="_blank"
							rel="noreferrer"
							className="link-mono"
							style={{ fontSize: "11.5px" }}
						>
							Google Scholar ↗
						</a> */}
					</motion.div>
				</div>

				<div
					style={{
						flex: "0 1 340px",
						minWidth: "220px",
						marginTop: "calc(15px + clamp(20px, 3vw, 34px))",
					}}
				>
					<motion.img
						src={process.env.PUBLIC_URL + HERO.portrait}
						alt={HERO.portraitAlt}
						style={{ width: "100%", height: "auto" }}
						initial={
							reduceMotion ? false : { opacity: 0, scale: 1.035 }
						}
						animate={{ opacity: 1, scale: 1 }}
						transition={{
							duration: 1,
							delay: 0.14,
							ease: [0.16, 1, 0.3, 1],
						}}
					/>
				</div>
			</div>
		</section>
	);
};

export default Hero;
